import { CustomizedSwitchWrapper } from 'components/CustomizedSwitchWrapper/CustomizedSwitchWrapper';
import { useHandleModuleNavigation } from 'hooks';
import { LayerRoute } from 'modules/multi-layer-drawer/components/LayerRoute/LayerRoute';
import { ModuleRoute } from 'modules/multi-layer-drawer/components/ModuleRoute/ModuleRoute';
import { PUSH_API_CREATOR_ROUTE_PATH, PUSH_API_ROUTE } from 'modules/push-api/config';
import { useMultiLayerDrawerEnabled } from '../../multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { PUSH_API_EDIT_ROUTE_PATH } from '../config';
import { PushApiCreator } from './PushApiCreator';
import { PushApiEditorPage } from './PushApiEditorPage';
import { PushApiPage } from './PushApiPage';

const path = PUSH_API_ROUTE;

export const PushApi = ({ history }) => {
    const handleNavigation = useHandleModuleNavigation({ history, path });

    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();

    return (
        <CustomizedSwitchWrapper>
            <LayerRoute
                strict
                exact
                path={PUSH_API_CREATOR_ROUTE_PATH}
                render={props => <PushApiCreator {...props} onCancel={handleNavigation} />}
                hasNestedRoutes
            />
            {isMultiLayerDrawerEnabled && (
                <LayerRoute
                    exact
                    path={PUSH_API_EDIT_ROUTE_PATH}
                    render={props => <PushApiEditorPage {...props} onCancel={handleNavigation} />}
                />
            )}
            <ModuleRoute path={path} render={() => <PushApiPage />} />
        </CustomizedSwitchWrapper>
    );
};
